export const ensureAudioUnlocked = async () => {
  const AudioContext = window.AudioContext || window.webkitAudioContext;
  if (!AudioContext) return null;

  // Lazily create AudioContext only after user gesture
  if (!window.__fitBudlyAudioContext) {
    try {
      window.__fitBudlyAudioContext = new AudioContext();
    } catch (err) {
      console.warn('Failed to create AudioContext', err);
      return null;
    }
  }

  const ctx = window.__fitBudlyAudioContext;
  if (ctx.state === 'suspended') {
    try {
      await ctx.resume();
    } catch (err) {
      console.warn('Audio resume failed', err);
    }
  }
  return ctx;
};

export const playTone = async (frequency, duration = 0.08, volume = 0.06) => {
  try {
    const ctx = await ensureAudioUnlocked();
    if (!ctx) return;
    const oscillator = ctx.createOscillator();
    const gain = ctx.createGain();
    oscillator.type = 'sine';
    oscillator.frequency.value = frequency;
    gain.gain.value = 0;
    oscillator.connect(gain);
    gain.connect(ctx.destination);
    
    // Use currentTime just in case
    const now = ctx.currentTime;
    // Ramp up quick
    gain.gain.linearRampToValueAtTime(volume, now + 0.01);
    // Decay
    gain.gain.exponentialRampToValueAtTime(0.0001, now + duration);
    
    oscillator.start(now);
    oscillator.stop(now + duration + 0.02);
  } catch (err) {
    console.warn('Audio playback failed', err);
  }
};

export const playButtonClick = () => {
  try {
    const AudioContext = window.AudioContext || window.webkitAudioContext;
    if (!AudioContext) return;

    if (!window.__fitBudlyAudioContext) {
      window.__fitBudlyAudioContext = new AudioContext();
    }

    const ctx = window.__fitBudlyAudioContext;
    if (ctx.state === 'suspended') {
      ctx.resume().catch(() => {});
    }

    // Create a phone-like click sound - quick, punchy, minimal
    const now = ctx.currentTime;
    const duration = 0.05; // 50ms very short click

    const osc = ctx.createOscillator();
    const gain = ctx.createGain();

    osc.type = 'sine';
    osc.frequency.value = 600; // Neutral frequency for phone click
    
    // Very quick attack and decay for that snappy feel
    gain.gain.setValueAtTime(0.15, now);
    gain.gain.exponentialRampToValueAtTime(0.01, now + duration);

    osc.connect(gain);
    gain.connect(ctx.destination);

    osc.start(now);
    osc.stop(now + duration);
  } catch (err) {
    console.warn('Button click sound error', err);
  }
};

export const playChime = async () => {
  try {
    const ctx = await ensureAudioUnlocked();
    if (!ctx) return;
    const gain = ctx.createGain();
    gain.gain.value = 0.0001; // Silent start
    gain.connect(ctx.destination);

    const playNote = (frequency, startTime, duration, volume) => {
      const osc = ctx.createOscillator();
      osc.type = 'sine';
      osc.frequency.value = frequency;
      
      const noteGain = ctx.createGain();
      noteGain.gain.value = 0.0001;
      osc.connect(noteGain);
      noteGain.connect(gain);
      
      noteGain.gain.setValueAtTime(0.0001, startTime);
      noteGain.gain.linearRampToValueAtTime(volume, startTime + 0.01);
      noteGain.gain.exponentialRampToValueAtTime(0.0001, startTime + duration);
      
      osc.start(startTime);
      osc.stop(startTime + duration + 0.02);
    };

    const now = ctx.currentTime;
    // Play immediately
    playNote(523.25, now, 0.12, 0.08);       // C5
    playNote(659.25, now + 0.12, 0.12, 0.08); // E5
    playNote(783.99, now + 0.24, 0.25, 0.09); // G5 (longer last note)

  } catch (err) {
    console.warn('Audio playback failed', err);
  }
};
